import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { verifyExtendKey } from '../../modules/Products/ProductsActions';
import PrimaryButton from '../Buttons/PrimaryButton';
import MessageDialog from '../MessageDialog/MessageDialog';
import Dialog from '../Dialog/Dialog';
import classes from "./ExtendActivation.module.css";
import Consts from '../../Consts';
import Password from '../Password/Password';

const ExtendActivation = ({ onClose, setShowActivationLicense }) => {
    const skusData = useSelector(s => s.skus.skus, shallowEqual);
    const [product, setProduct] = useState({});
    const [messageContent, setMessageContent] = useState({
        title: "",
        message: ""
    });
    const [showMessageDialog, setShowMessageDialog] = useState(false);
    const [password, setPassword] = useState({ password: "" });
    const [skus, setSkus] = useState([]);

    useEffect(() => {
        let products = skusData.filter((e) => e.sku !== "sku001")
        setSkus(products)
        setProduct(state => ({ ...state, name: products?.[0]?.displayName }));
    }, [skusData]);

    async function activateHandler() {
        try {
            const response = await verifyExtendKey(password);
            const data = response?.data;
            if (data?.success) {
                onClose();
                setShowActivationLicense({ show: true, product });
            } else {
                setMessageContent({
                    title: "Failed",
                    message: "Sorry! You have entered wrong password.",
                })
                setShowMessageDialog(true);
            }
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <>
            {
                showMessageDialog && <MessageDialog {...messageContent} closeText='Close' isCancel
                    onCancel={() => setShowMessageDialog(false)}
                    width={Consts.MESSAAGE_DIALOG_WIDTH}
                />
            }
            <Dialog
                showCloseIcon={true}
                title={`Extend Activation `}
                width="20rem"
                content={
                    <div className={classes.activateProductContent}>
                        <div className={classes.container}>
                            <label htmlFor='select' className={classes.activationLabel}>
                                <span>Select product</span>
                            </label>
                            <select onChange={(e) => setProduct(state => ({ ...state, name: e.target.value }))} value={product.name}>
                                {skus.map((sku) => {
                                    return <option key={sku.sku} value={sku.displayName}>
                                        {sku.displayName}
                                    </option>
                                })}
                            </select>
                        </div>
                        <div className={classes.container}>
                            <label htmlFor='input' className={classes.activationLabel}>
                                <span>Specify password to unlock</span>
                            </label>
                            <Password id="password"
                                width="100%" height="2rem"
                                onCommit={() => !!password.password ? activateHandler() : {}}
                                onChange={(e) =>
                                    setPassword((prevState) => {
                                        return {
                                            ...prevState,
                                            password: e.target.value
                                        }
                                    })
                                } autoComplete="off" />
                        </div>
                    </div>
                }
                footer={
                    <div className={classes.activateProductActions}>
                        <div>
                            <PrimaryButton onClick={() => onClose(false)} negative>
                                Cancel
                            </PrimaryButton>
                            <PrimaryButton onClick={activateHandler} positive disabled={!password.password}>
                                OK
                            </PrimaryButton>
                        </div>
                    </div>
                }
            />
        </>
    );
};

export default ExtendActivation;